import { post } from '../utils/httpClient'
import { getRedDataApiPaths } from '../config'
import { VoyagesOrderRequest } from '../redux/orders/types'

export const apiPostVoyagesOrder = async (order: VoyagesOrderRequest, stepUp = false) => {
  return post(getRedDataApiPaths().GENERATE_B2C_API('/v1/accounts/me/orders'), true, stepUp, order)
}
